import Ajax from '../modules/ajax';

export default class {
    ajax;
    btnsFormOrder = document.querySelectorAll('.js_form-order-address-submit');

    constructor() {
        this.ajax = new Ajax;
        this.listen();
    }

    showSuccessModal() {
        let modalSuccess = new bootstrap.Modal(document.getElementById('modalOrderSuccess'));
        modalSuccess.show();
    };

    listen() {
        this.btnsFormOrder.forEach(btnSubmit => {
            btnSubmit.addEventListener('click', (event) => {
                event.preventDefault();
                let form = btnSubmit.closest('.js_form-address-order'),
                    data = {
                        width: form.querySelector('input[name="board_width"]:checked').value,
                        length: form.querySelector('input[name="board_length"]:checked').value,
                        type: form.querySelector('.js_order-type').value,
                        name: form.querySelector('.js_order-name').value,
                        phone: form.querySelector('.js_order-phone').value,
                        address: form.querySelector('.js_order-address').value,
                    }

                form.querySelectorAll('.is-invalid').forEach(n => n.classList.remove('is-invalid'));

                let success = (response) => {
                    if (response.data.result == 'success') {
                        if (btnSubmit.closest('.modal')) {
                            let btnCloseOrderModal = btnSubmit.closest('.modal').querySelector('.btn-close')
                            btnCloseOrderModal.click();
                        }
                        form.reset();
                        setTimeout(() => {
                            this.showSuccessModal();
                        }, 50)
                    }
                };

                let fail = (error) => {
                    if (error.response.data.errors) {
                        let errors = error.response.data.errors;
                        for (var e in errors) {
                            let el = form.querySelector('input[name="' + e + '"]');
                            el.classList.add('is-invalid');
                        }
                    }
                };

                this.ajax.send(data, success, fail, '/ajax/order-address');
            });
        })
    }
}
